import homeIcon from '../components/Main-page-wrapper/Dashboard/assets/homeIcon.svg'
//import dashboardIcon from "../components/Main-page-wrapper/Dashboard/assets/dashboardIcon.svg";
import statistikIcon from '../components/Main-page-wrapper/Dashboard/assets/statistikIcon.svg'
import archivIcon from '../components/Main-page-wrapper/Dashboard/assets/archivIcon.svg'
import settingsIcon from '../components/Main-page-wrapper/Dashboard/assets/settingsIcon.svg'
import combotIcon from '../components/Main-page-wrapper/Dashboard/assets/combotIcon.svg'
import lightBulbIcon from '../components/Main-page-wrapper/Dashboard/assets/light-bulb-idea.svg'
//import wordMicrosoftIcon from "../components/Main-page-wrapper/Dashboard/assets/wordMicrosoftIcon.svg";
//import supportIcon from "../components/Main-page-wrapper/Dashboard/assets/supportIcon.svg";
//import personIcon from "../components/Main-page-wrapper/Header/assets/Icon-material-person.svg";
import Spell from '../components/Analysis/Tabs/Accordion/Blocks/Spell'
import LinguisticClimate from '../components/Analysis/Tabs/Accordion/Blocks/LinguisticClimate'
import Readability from '../components/Analysis/Tabs/Accordion/Blocks/Readability'
import Terminology from '../components/Analysis/Tabs/Accordion/Blocks/Terminology'
import CorporateLanguage from '../components/Analysis/Tabs/Accordion/Blocks/CorporateLanguage'
import Tonality from '../components/Analysis/Tabs/Accordion/Blocks/Tonality'
import GrammarAndStyle from '../components/Analysis/Tabs/Accordion/Blocks/GrammarAndStyle'
import TerminologyModal from '../components/Analysis/ModalWindows/TerminologyModal'
import SpellModal from '../components/Analysis/ModalWindows/SpellModal'
import LinguisticClimateModal from '../components/Analysis/ModalWindows/LinguisticClimateModal'
import InfoModal from '../components/Analysis/ModalWindows/InfoModal'
import ReadabilityModal from '../components/Analysis/ModalWindows/ReadabilityModal'
import LanguageToolModal from '../components/Analysis/ModalWindows/LanguageToolModal'
import benutzerIcon from '../components/Administration/assets/benutzerIcon.svg'
import benutzerIconLight from '../components/Administration/assets/benutzerIconLight.svg'
import benutzerIconDark from '../components/Administration/assets/benutzerIconDark.svg'
import groupIcon from '../components/Administration/assets/groupIcon.svg'
import groupIconLight from '../components/Administration/assets/groupIconLight.svg'
import groupIconDark from '../components/Administration/assets/groupIconDark.svg'
import terminologiesIcon from '../components/Administration/assets/terminoliesIcon.svg'
import terminologiesIconLight from '../components/Administration/assets/terminoliesIconLight.svg'
import terminologiesIconDark from '../components/Administration/assets/terminoliesIconDark.svg'
import textSortIcon from '../components/Administration/assets/textSortIcon.svg'
import textSortIconLight from '../components/Administration/assets/textSortIconLight.svg'
import textSortIconDark from '../components/Administration/assets/textSortIconDark.svg'
import textBinIcon from '../components/Administration/assets/textBinIcon.svg'
import textBinIconLight from '../components/Administration/assets/textBinIconLight.svg'
import textBinIconDark from '../components/Administration/assets/textBinIconDark.svg'
import alIcon from '../components/Administration/assets/alIcon.svg'
import alIconLight from '../components/Administration/assets/alIconLight.svg'
import alIconDark from '../components/Administration/assets/alIconDark.svg'
import companyIcon from '../components/Administration/assets/companyIcon.svg'
import companyIconLight from '../components/Administration/assets/companyIconLight.svg'
import companyIconDark from '../components/Administration/assets/companyIconDark.svg'
import Experimental from '../components/Analysis/Tabs/Accordion/Blocks/Experimental'
import SuggestionModal from '../components/Analysis/ModalWindows/SuggestionModal'
import { HelpOutline } from '@material-ui/icons'
import TextMessagesTemplate from '../assets/messages/TextMessagesTemplate'



const wordsCloudTemplate = {
  de_DE: {
    funcWordData: ['countConjunctions', 'countArticles', 'countPronouns', 'countPrepositions', 'countParticles'],
    catType: [{
      label: 'Adjectives',
      countData: 'countAdjectives',
      color: "#3fbdff"
    },
    {
      label: 'Nouns',
      countData: 'countNouns',
      color: "#415c98"
    },
    {
      label: 'Verbs',
      countData: 'countVerbs',
      color: "#5e47d9"
    },
    {
      label: 'Numbers',
      countData: 'countNumbers',
      color: "#2b7e36"
    }],
    ignoreTypes: ['sgml','xy'],
    ignoreTags: ["XY", "$,", "$.", "$(", ""],
    ignoreWords: [],
    ignoreLemmas: ['<unknown>'],

  },
  en_GB: {
    funcWordData: ['countArticles', 'countPronouns', 'countParticles','countPrepositionsConjunctions'],
    catType: [{
      label: 'Adjectives',
      countData: 'countAdjectives',
      color: "#3fbdff"
    },
    {
      label: 'Nouns',
      countData: 'countNouns',
      color: "#415c98"
    },
    {
      label: 'Verbs',
      countData: 'countVerbs',
      color: "#5e47d9"
    }],
    ignoreTypes: ['sgml','xy'],
    ignoreTags: ['$',':','*','SYM','SENT','@','#',',',')','(','LS'],
    ignoreWords: [],
    ignoreLemmas: ['<unknown>']
  }
}

const languageLevelToString = [
  { level: 'A1', threshold: 94, color: '#327D15' },
  { level: 'A2', threshold: 84, color: '#327D15'  },
  { level: 'B1', threshold: 74, color: '#4BBD1F'  },
  { level: 'B2', threshold: 70, color: '#BD911F'  },
  { level: 'C1', threshold: -100, color: '#BD421F'  },
  { level: 'C2', threshold: -1000, color: '#ff0707'  },
]
// Category Type List:
const categoryTypeList = [
  { id: 'positive', name: 'cattype_positive' },
  { id: 'negative', name: 'cattype_negative' },
  { id: 'allowedlist', name: 'cattype_allowedList' },
  // { id: 'tonality', name: "cattype_tonality" },
  // { id: 'color', name: "cattype_color" },
  // { id: 'nominal', name: "cattype_nominal" },
  // { id: 'personal/neutral', name: "cattype_personal/neutral" }
]

const clixCategories = [
  'colorBlue',
  'colorGreen',
  'colorRed',
  'colorYellow'
]

const clixDigits = [
  'formulaHix',
  'formulaPersonalNeutralScaleValue',
  'formulaTonalityScaleValue',
  'countScoreNeutral',
  'countScorePersonal',
  'countSttr',
]

const clixArrays = [
  'countFutureTenseInSentence',
  'countInfinitiveConstructions',
  'countNominalStyle',
  'countPassiveVoiceInSentence',
  'moreClausesInWords',
  'moreParagraphsInWords',
  'moreSentencesInBrackets',
  'moreSentencesInClauses',
  'moreSentencesInPrepositions',
  'moreSentencesInWords',
  'moreWordsInLetters',
]

const compareShowValues = [
  {
    name: 'moreSentencesInClauses',
    prefix: 'arraymax',
    type: 'arraysize',
    title: 'COMPLEX SENTENCES',
    subTitle: 'Complicated sentence',
    lText: '',
    lTitle: 'Sentences are too complicated'
  },
  {
    name: 'moreSentencesInWords',
    prefix: 'arraymax',
    type: 'arraysize',
    title: 'LONG SENTENCES',
    subTitle: 'Longest sentence',
    lText: '',
    lTitle: 'Sentences are too long'
  },
  {
    name: 'moreWordsInLetters',
    prefix: 'arraymax',
    type: 'arraysize',
    title: 'LONG WORDS',
    subTitle: 'Longest words',
    lText: '',
    lTitle: 'Words are too long'
  },
]

const compareShowValuesCLIX = []

const dataHixValues = [
  'dataHix.Amstad',
  'dataHix.Lix',
  'dataHix.GSMOG',
  'dataHix.WSTF'
]

const compareThemeColors = {
  red: '#b00014',
  yellow: '#dd540a',
  green: '#9db10d',
  blue: '#415C98'
}

const LINGUISTIC_CLIMATE_TITLE_INITIALS = {
  rational: 'R',
  conservative: 'C',
  innovative: 'I',
  innovativ: 'I',
  emotional: 'E',
  konservativ: 'K'
}

const colorKeyToTitle = {
  colorBlue: { de: 'rational', en: 'rational' },
  colorRed: { de: 'emotional', en: 'emotional' },
  colorGreen: { de: 'konservativ', en: 'conservative' },
  colorYellow: { de: 'innovativ', en: 'innovative' },
}

const userSettingColor = [
  { name: 'colorBlue', color: '#0643cc' },
  { name: 'colorRed', color: '#DD0D08' },
  { name: 'colorYellow', color: '#ffa603' },
  { name: 'colorGreen', color: '#43AB1B' }
]

const archiveTypes = ['user', 'user_group', 'company']

const defaultArchiveColumns = ['archive_name', 'owner', 'benchmark_id', 'create_time', 'formulaSPIX', 'formulaHix', 'formulaCLIX', 'update_time']

const defaultUsersColumns = ['user_name', 'active', 'last_name', 'user_group_name', 'company_name', 'create_time']

const singleGroupLevel = [
  {
    id: 101,
    control: 'switch', labelPlacementEnd: true,
  },
  {
    id: 102,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 103,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 104,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 105,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 106,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 109,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 110,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 121,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 123,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 131,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 141,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 702,
    control: 'switch',
    labelPlacementEnd: true,
  }
]

const companyLevel = [
  {
    id: 201,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 202,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 203,
    control: 'switch', labelPlacementEnd: true,
  },
  {
    id: 204,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 205,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 206,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 207,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 208,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 209,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 210,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 221,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 223,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 231,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 241,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 703,
    control: 'switch',
    labelPlacementEnd: true,
  }
]

const overCompanyLevel = [
  {
    id: 306,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 307,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 308,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 309,
    control: 'switch',
    labelPlacementEnd: true,
  }
]

const specialRights = [
  {
    id: 401,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 402,
    control: 'switch',
    labelPlacementEnd: true,
  },
  {
    id: 403,
    control: 'switch',
    labelPlacementEnd: true,
  }
]

const termHeaders =
{
  'words': { 'de_DE': 'Begriff', 'en_GB': 'words' },
  'description': { 'de_DE': 'Erklärung', 'en_GB': 'description' },
  'replacements': { 'de_DE': 'Ersetzung', 'en_GB': 'replacement_words' }
}

const chartMax = {
  hix: 20,
  clix: 100,
  flesch: 100
}

const userRights = {
  'rights_label_101': 101,
  'rights_label_102': 102,
  'rights_label_103': 103,
  'rights_label_104': 104,
  'rights_label_105': 105,
  'rights_label_106': 106,
  'rights_label_109': 109,
  'rights_label_110': 110,
  'rights_label_121': 121,
  'rights_label_123': 123,
  'rights_label_131': 131,
  'rights_label_141': 141,
  'rights_label_151': 151,

  'rights_label_201': 201,
  'rights_label_202': 202,
  'rights_label_203': 203,
  'rights_label_204': 204,
  'rights_label_205': 205,
  'rights_label_206': 206,
  'rights_label_207': 207,
  'rights_label_208': 208,
  'rights_label_209': 209,
  'rights_label_210': 210,
  'rights_label_221': 221,
  'rights_label_223': 223,
  'rights_label_231': 231,
  'rights_label_241': 241,
  'rights_label_251': 251,

  'rights_label_306': 306,
  'rights_label_307': 307,
  'rights_label_308': 308,
  'rights_label_309': 309,

  'rights_label_401': 401,
  'rights_label_402': 402,
  'rights_label_403': 403,
  'rights_label_404': 404,

  'rights_label_601': 601,
  'rights_label_602': 602,
  'rights_label_701': 701,
  'rights_label_702': 702,
  'rights_label_703': 703,
}

const userRightsGroupLevel = [
  101,
  102,
  103,
  104,
  105,
  106,
  109,
  110,
  121,
  123,
  131,
  141,
  702,
  601
]

const autoAnalyseLanguage = {
  auto: { nativeName: 'Auto' }
}

const neededValues = [
  'formulaHix',
  'formulaFlesch',
  'formulaCLIX'
]

const options = {
  'maximum_users': '',
  'enabled_benchmark_templates': '',
  'edit_archives': '',
  'default_language': '',
  'analyse_language_texttype': '',
  'enabled_frontend_sections': '',
  'enabled_export_template': '',
  'export_template_word': '',
  'enable_textbin': false,
  'default_company_settings': '',
  'enabled_texttypes': '',
  'view_archives': '',
  'color_schema': '',
  'analyse_tonality': '',
  'tonality_visibility': false,
  'export_template_single': '',
  'export_template_excel': '',
  'modal_settings': '',
  'expired_time': '',

}

const enabledUserOptions = [
  'expired_time'
]

const accessKeys = {
  runAnalyse: 'A',
  reloadAnalyse: 'R',
  openFile: 'O',
  startNewAnalyse: 'N',
  singleDashboard: 'S',
  dashboardCompare: 'D',
  navbarOpen: 'L',
  navbarClose: 'B',
  aiMode: 'K',
  ainstein: 'T',
  generatorMode: 'G',
  archive: 'X',
  administration: 'Y',
  handbook: 'H',
  home: 'P',
  cockpit: 'C',
  editorMenu: 'M',
  summAi: 'I',
  benchmarkSelectionTop: 'F',
  benchmarkSelectionBottom: 'G',
  languageSelection: 'J',
  aiTypeSelection: 'J',
  aiBenchmarkSelection: 'F',
  aiShowOptimization: 'S',
  aiOptInput: 'I',
  aiAcceptLeft:'M',
  aiAcceptRight: 'N',
  aiUploadBtn: 'O',
  aiDiscardButton: 'D',
  aiSwitchText:'G',
  genOptimize: 'O',
  genOptInput: 'I',
  pdfReport: 'R',
  downloadPdf:'R',
  toolTip: 'Z',
  closeModal: 'Z',
  editor: 'W',
  editorSecond: 'Q',
}

const pageMeta = {
  '/': {
    title: 'page_title_home'
  },
  '/ainstein': {
    title: 'page_title_ainstein'
  },
  '/authorization': {
    title: 'page_title_login'
  },
  '/profile': {
    title: 'page_title_profile'
  },
  '/profile/2fa/ga': {
    title: 'page_title_profile_2fa_ga'
  },
  '/profile/messages': {
    title: 'page_title_profile_messages'
  },
  '/profile/messages/:id': {
    title: 'page_title_profile_messages_id'
  },
  '/profile/notifications': {
    title: 'page_title_profile_notifications'
  },
  '/text-generation': {
    title: 'page_title_text_generation'
  },
  '/iframe': {
    title: 'page_title_iframe'
  },
  '/archive': {
    title: 'page_title_archive'
  },
  '/dashboard/compare/filters/:type': {
    title: 'page_title_dashboard_compare_filters_type'
  },
  '/dashboard/combine': {
    title: 'page_title_dashboard_combine'
  },
  '/dashboard/single/combine': {
    title: 'page_title_dashboard_single_combine'
  },
  '/dashboard/:type': {
    title: 'page_title_dashboard_type'
  },
  '/dashboard/:type/HIX': {
    title: 'page_title_dashboard_type_HIX'
  },
  '/dashboard/:type/CLIX': {
    title: 'page_title_dashboard_type_CLIX'
  },
  '/dashboard/:type/tonality': {
    title: 'page_title_dashboard_type_tonality'
  },
  '/dashboard/:type/speech-climate': {
    title: 'page_title_dashboard_type_speech_climate'
  },
  '/dashboard/:type/vocabulary': {
    title: 'page_title_dashboard_type_vocabulary'
  },
  '/administration': {
    title: 'page_title_administration'
  },
  '/administration/user': {
    title: 'page_title_administration_user'
  },
  '/administration/user/update/add-new-user': {
    title: 'page_title_administration_user_add_new_user'
  },
  '/administration/user/update/:id': {
    title: 'page_title_administration_user_update'
  },
  '/administration/groups': {
    title: 'page_title_administration_groups'
  },
  '/administration/group/update/add-new-group': {
    title: 'page_title_administration_group_add_new_group'
  },
  '/administration/group/update/:id': {
    title: 'page_title_administration_group_update'
  },
  '/administration/company': {
    title: 'page_title_administration_company'
  },
  '/administration/company/update/add-new-company': {
    title: 'page_title_administration_company_add_new_company'
  },
  '/administration/company/update/:id': {
    title: 'page_title_administration_company_update'
  },
  '/administration/text-types': {
    title: 'page_title_administration_text_types'
  },
  '/administration/text-types/update/:id': {
    title: 'page_title_administration_text_types_update'
  },
  '/administration/text-types/add-new-text-type': {
    title: 'page_title_administration_text_types_add_new_text_type'
  },
  '/administration/terminology': {
    title: 'page_title_administration_terminology'
  },
  '/administration/terminology/update/:categoryID': {
    title: 'page_title_administration_terminology_update'
  },
  '/administration/terminology/allowedList': {
    title: 'page_title_administration_terminology_allowedList'
  },
  '/administration/terminology/textbin': {
    title: 'page_title_administration_terminology_textbin'
  },
  '/administration/cleaning-rules': {
    title: 'page_title_administration_cleaning_rules'
  },
  '/administration/info/best-practice': {
    title: 'page_title_administration_info_best_practice'
  },
  '/administration/info/info-messages': {
    title: 'page_title_administration_info_info_messages'
  },
  '/administration/info/logs': {
    title: 'page_title_administration_info_logs'
  },
}

const keyAttributes = [{ key: accessKeys.cockpit, attribute: 'data-accordion-item' }, { key: accessKeys.editorMenu, attribute: 'data-menu-item' }]

const tabIndexes = {
  //login Page
  username: 1001,
  password: 1002,
  forgetPassword: 1003,
  loginButton: 1004,

  //Top
  navHamburger: 2001,
  TlLogo: 2002,
  themeButton: 2010,
  notificationButton: 2011,
  notificationButtonMessage: 2012,
  notificationButtonMessageTick: 2080,
  notificationButtonMessageOverview: 2139,
  avatarButton: 2140,
  preferences: 2141,
  logout: 2142,

  //Analysis Part
  benchmarkSelection: 3001,
  hixWrapper: 3003,
  fleschWrapper: 3004,
  clixWrapper: 3005,
  colorWordsWrapper: 3006,
  tonalityWrapper: 3007,
  editorMenuBox: 3009,
  editorMenu: 3011,
  uploadDoc: 3027,
  refreshAnalysis: 3027,
  enterEditor: 3028,
  analysisLanguage: 3029,
  analysisTextTypeInput: 3030,
  analysisTextType: 3031,

  //Cockpit
  cockpit: 4000,
  analyseButton: 4001,
  ainsteinButton: 4002,

  //Filters
  red: 4003,
  yellow: 4004,
  green: 4005,
  hix: 4006,
  flesch: 4007,
  clix: 4008,

  //Parameters
  accordions: [4010, 4011, 4012, 4013, 4014, 4015, 4016, 4017, 4018, 4019, 4020],

  //Generator Page

  genResultInputFieldBtn: 3001,
  genResultInputField: 3002,
  genResultInputFieldClose: 3003,
  genInputField: 3004,
  genHixWrapper: 3005,
  genFleschWrapper: 3006,
  genClixWrapper: 3007,
  genTonalityWrapper: 3008,
  genLanguageWrapper: 3009,
  genRefreshButton: 3010,
  genAcceptTextButton: 3011,
  genButton: 3018,
  genOptInput: 3019,
  genTextTypeSelect: 3020,
  genSelections: [3021, 3022, 3023, 3024, 3025, 3026, 3027, 3028, 3029, 3030, 3031, 3032, 3033, 3034, 3035, 3036, 3037, 3038, 3039, 3040, 3041, 3042, 3043, 3044, 3045, 3046, 3047, 3048, 3049, 3050],
  genOptBtn: 3051,


  //AI Mode
  aiDiscardButton: 3001,
  aiHixWrapperLeft: 3002,
  aiFleschWrapperLeft: 3003,
  aiClixWrapperLeft: 3004,
  aiTonalityWrapperLeft: 3005,
  aiLangLevelWrapperLeft: 3006,
  aiRefreshButtonLeft: 3007,
  aiAcceptLeft: 3008,

  aiHixWrapperRight: 3009,
  aiFleschWrapperRight: 3010,
  aiClixWrapperRight: 3011,
  aiTonalityWrapperRight: 3012,
  aiLangLevelWrapperRight: 30013,
  aiRefreshButtonRight: 3014,
  aiAcceptRight: 3015,

  
  aiUploadBtn: 3016,
  aiSelectAi: 3017,
  aiTextType: 3018,
  aiShowOptimization: 3019,
  aiOptInput: 3020,
  aiSelections: [3021, 3022, 3023, 3024, 3025, 3026, 3027, 3028, 3029, 3030, 3031, 3032, 3033, 3034, 3035, 3036, 3037, 3038, 3039, 3040, 3041, 3042, 3043, 3044, 3045, 3046, 3047, 3048, 3049, 3050],
  aiOptBtn: 3051,
  aiRunBtn: 3052,
  aiSwitchText: 3053,

  //Bottom
  impressum: 5001,
  datenschutz: 5002,

}

const processSettings = (settings) => {
  let categories = {}
  for (const [key, value] of Object.entries(settings)) {
    if (!categories[value.category]) {
      categories[value.category] = []
    }
    const values = Object.entries(value.values).map(([key, value]) => {
      return {key, type: value[0]}
    }
    )
    categories[value.category].push({key, values})
  }
  return categories
}

const textTypeTableHeaders = ["Section Name", 'enabled', "Values", "Actions"]

const catTypes = { 
  allow_list_sections: ['allowedlist'],
  corporate_language_sections: ['positive', 'negative'],
  text_cleaning_sections:  ['positive', 'negative'],
  terms_sections: ['positive', 'negative'],
  language_level_sections: ['positive', 'negative']
}

const listNestedFields = [
  { id: 1, name: "enabled", control: "switch" },
  { id: 2, name: "checkSynonym", control: "switch" },
  { id: 3, name: "clix", control: "text", type: 'number' },
  { id: 4, name: "ignoreCaseFirst", control: "switch" },
  { id: 5, name: "relations", control: "text", type: 'json' },
  { id: 6, name: "scaleFrom", control: "text", type: 'number' },
  { id: 7, name: "scaleTo", control: "text", type: 'number' },
  { id: 8, name: "sort", control: "text", type: 'number' },
  { id: 9, name: "target", control: "text", type: 'number' },
  { id: 10, name: "yellowGreen", control: "text", type: 'number' },
  { id: 11, name: "yellowRed", control: "text", type: 'number' }
]

const fieldSequence = {
 sequence: [ 'clix', 'scaleFrom', 'scaleTo', 'target', 'yellowGreen', 'yellowRed', 'sort', 'checkSynonym', 'ignoreCaseFirst', 'relations'], 
 showFirst : ['clix', 'target']
}

const allSectionNames = {
  withLists: ['allow_list_sections', 'corporate_language_sections', 'text_cleaning_sections', 'terms_sections', 'language_level_sections'],
  withoutLists: ['ai_sections', 'tonality_section', 'other_sections', 'averages_section', 'color_word_sections','exceedances_sections', 'formulas_section', 'counting_section', 'part_of_speech_count_section']
}

const allSectionNamesAdmin = {
  withLists: ['corporate_language_sections', 'terms_sections'],
  withoutLists: ['exceedances_sections']
}

const AI_SECTIONS_FIELDS = [
  { id: 1, name: "customPrompt", label: "AiPrompt", key: "customPromptFields" },
  { id: 2, name: "magicWandPrompt", label: "MagicWandPrompt", key: "magicWandPromptFields" },
]

const TONALITY_SECTION_FIELDS = [
  { id: 1, name: "countTonalityAllPositive", label: "CountTonalityAllPositive", key: "countTonalityAllPositiveFields" },
  { id: 2, name: "countTonalityAllNegative", label: "CountTonalityAllNegative", key: "countTonalityAllNegativeFields" },
  { id: 3, name: "countTonalityClausePositive", label: "CountTonalityClausePositive", key: "countTonalityClausePositiveFields" },
  { id: 4, name: "countTonalityClauseNegative", label: "CountTonalityClauseNegative", key: "countTonalityClauseNegativeFields" },
  { id: 5, name: "countTonalityParagraphPositive", label: "CountTonalityParagraphPositive", key: "countTonalityParagraphPositiveFields" },
  { id: 6, name: "countTonalityParagraphNegative", label: "CountTonalityParagraphNegative", key: "countTonalityParagraphNegativeFields" },
  { id: 7, name: "dataTonalityNegative", label: "DataTonalityNegative", key: "dataTonalityNegativeFields" },
  { id: 8, name: "countTonalityAllNeutral", label: "CountTonalityAllNeutral", key: "countTonalityAllNeutralFields" },
  { id: 9, name: "countTonalityClausePersonal", label: "CountTonalityClausePersonal", key: "countTonalityClausePersonalFields" },
  { id: 10, name: "countTonalityClauseNeutral", label: "CountTonalityClauseNeutral", key: "countTonalityClauseNeutralFields" },
  { id: 11, name: "countTonalityParagraphPersonal", label: "CountTonalityParagraphPersonal", key: "countTonalityParagraphPersonalFields" },
  { id: 12, name: "countTonalityParagraphNeutral", label: "CountTonalityParagraphNeutral", key: "countTonalityParagraphNeutralFields" },
  { id: 13, name: "formulaPersonalNeutralScaleValue", label: "FormulaPersonalNeutralScaleValue", key: "formulaPersonalNeutralScaleValueFields" },
  { id: 14, name: "dataTonalityPersonal", label: "DataTonalityPersonal", key: "dataTonalityPersonalFields" },
  { id: 15, name: "dataTonalityNeutral", label: "DataTonalityNeutral", key: "dataTonalityNeutralFields" },
  { id: 16, name: "countScorePersonal", label: "CountScorePersonal", key: "countScorePersonalFields" },
  { id: 17, name: "countScoreNeutral", label: "CountScoreNeutral", key: "countScoreNeutralFields" },
  { id: 18, name: "dataTonalityPositive", label: "DataTonalityPositive", key: "dataTonalityPositiveFields" },
  { id: 19, name: "formulaTonalityScaleValue", label: "FormulaTonalityScaleValue", key: "formulaTonalityScaleValueFields" },
  { id: 20, name: "countTonalityAllPersonal", label: "CountTonalityAllPersonal", key: "countTonalityAllPersonalFields" },
]

const OTHER_SECTIONS_FIELDS = [
  { id: 1, name: "languageTool", label: "LanguageTool", key: "languageToolFields" },
  { id: 2, name: "dataIgnoredText", label: "DataIgnoredText", key: "dataIgnoredTextFields" },
  { id: 3, name: "languageLevel", label: "LanguageLevel", key: "languageLevelFields" },
  { id: 4, name: "dataAllowedList", label: "DataAllowedList", key: "dataAllowedListFields" },
  { id: 5, name: "dataBodyRecognition", label: "DataBodyRecognition", key: "dataBodyRecognitionFields" },
  { id: 6, name: "dataTokenizer", label: "DataTokenizer", key: "dataTokenizerFields" },
  { id: 7, name: "dataTokenizerErrors", label: "DataTokenizerErrors", key: "dataTokenizerErrorsFields" },
  { id: 8, name: "replaceInText", label: "ReplaceInText", key: "replaceInTextFields" },
  { id: 9, name: "dataHunSpell", label: "DataHunSpell", key: "dataHunSpellFields" },
  { id: 10, name: "dataTextClassification", label: "DataTextClassification", key: "dataTextClassificationFields" },
  { id: 11, name: "formulaSPIX", label: "FormulaSPIX", key: "formulaSPIXFields" },
  { id: 12, name: "dataRemoveBorder", label: "DataRemoveBorder", key: "dataRemoveBorderFields" },
  { id: 13, name: "convertedText", label: "ConvertedText", key: "convertedTextFields" },
  { id: 14, name: "highlighting", label: "Highlighting", key: "highlightingFields" },
  { id: 15, name: "textTextCleaning", label: "TextTextCleaning", key: "textTextCleaningFields" },
]

const AVERAGES_SECTION_FIELDS = [
  { id: 1, name: "meanSentenceLengthInLetters", label: "MeanSentenceLengthInLetters", key: "meanSentenceLengthInLettersFields" },
  { id: 2, name: "meanSentenceLengthInSyllables", label: "MeanSentenceLengthInSyllables", key: "meanSentenceLengthInSyllablesFields" },
  { id: 3, name: "meanSentenceLengthInWords", label: "MeanSentenceLengthInWords", key: "meanSentenceLengthInWordsFields" },
  { id: 4, name: "meanWordLengthInLetters", label: "MeanWordLengthInLetters", key: "meanWordLengthInLettersFields" },
  { id: 5, name: "meanWordLengthInSyllables", label: "MeanWordLengthInSyllables", key: "meanWordLengthInSyllablesFields" },
  { id: 6, name: "meanClauseLengthInWords", label: "MeanClauseLengthInWords", key: "meanClauseLengthInWordsFields" },
  { id: 7, name: "meanClauseLengthInSyllables", label: "MeanClauseLengthInSyllables", key: "meanClauseLengthInSyllablesFields" },
  { id: 8, name: "meanClauseLengthInLetters", label: "MeanClauseLengthInLetters", key: "meanClauseLengthInLettersFields" },
]

const COLOR_WORD_SECTIONS_FIELDS = [
  { id: 1, name: "colorRed", label: "ColorRed", key: "colorRedFields" },
  { id: 2, name: "colorGreen", label: "ColorGreen", key: "colorGreenFields" },
  { id: 3, name: "colorYellow", label: "ColorYellow", key: "colorYellowFields" },
  { id: 4, name: "colorBlue", label: "ColorBlue", key: "colorBlueFields" },
]

const COUNTING_SECTION_FIELDS = [
  { id: 1, name: "countSentences", label: "CountSentences", key: "countSentencesFields" },
  { id: 2, name: "countClauses", label: "CountClauses", key: "countClausesFields" },
  { id: 3, name: "countLongestSentenceInWords", label: "CountLongestSentenceInWords", key: "countLongestSentenceInWordsFields" },
  { id: 4, name: "countSyllables", label: "CountSyllables", key: "countSyllablesFields" },
  { id: 5, name: "countWords", label: "CountWords", key: "countWordsFields" },
  { id: 6, name: "countLongestWordInCharacters", label: "CountLongestWordInCharacters", key: "countLongestWordInCharactersFields" },
  { id: 7, name: "countHeading", label: "CountHeading", key: "countHeadingFields" },
  { id: 8, name: "countParagraphs", label: "CountParagraphs", key: "countParagraphsFields" },
  { id: 9, name: "countPassiveVoiceInSentence", label: "CountPassiveVoiceInSentence", key: "countPassiveVoiceInSentenceFields" },
  { id: 10, name: "countFutureTenseInSentence", label: "CountFutureTenseInSentence", key: "countFutureTenseInSentenceFields" },
  { id: 11, name: "countInfinitiveConstructions", label: "CountInfinitiveConstructions", key: "countInfinitiveConstructionsFields" },
  { id: 12, name: "countSttr", label: "CountSttr", key: "countSttrFields" },
  { id: 13, name: "countSubjunctiveVerbs", label: "CountSubjunctiveVerbs", key: "countSubjunctiveVerbsFields" },
  { id: 14, name: "countSubjunctiveClauses", label: "CountSubjunctiveClauses", key: "countSubjunctiveClausesFields" },
  { id: 15, name: "countComplexWords", label: "CountComplexWords", key: "countComplexWordsFields" },
  { id: 16, name: "countPrepositionsConjunctions", label: "CountPrepositionsConjunctions", key: "countPrepositionsConjunctionsFields" },
  { id: 17, name: "countVerbalBlocks", label: "CountVerbalBlocks", key: "countVerbalBlocksFields" },
  { id: 18, name: "countCharacters", label: "CountCharacters", key: "countCharactersFields" },
  { id: 19, name: "countCharactersNoSpaces", label: "CountCharactersNoSpaces", key: "countCharactersNoSpacesFields" },
  { id: 20, name: "countNominalStyle", label: "CountNominalStyle", key: "countNominalStyleFields" },
]

const PART_OF_SPEECH_COUNT_SECTION_FIELDS = [
  { id: 1, name: "countNumbers", label: "CountNumbers", key: "countNumbersFields" },
  { id: 2, name: "countVerbs", label: "CountVerbs", key: "countVerbsFields" },
  { id: 3, name: "countArticles", label: "CountArticles", key: "countArticlesFields" },
  { id: 4, name: "countParticles", label: "CountParticles", key: "countParticlesFields" },
  { id: 5, name: "countPronouns", label: "CountPronouns", key: "countPronounsFields" },
  { id: 6, name: "countConjunctions", label: "CountConjunctions", key: "countConjunctionsFields" },
  { id: 7, name: "countPrepositions", label: "CountPrepositions", key: "countPrepositionsFields" },
  { id: 8, name: "countMisc", label: "CountMisc", key: "countMiscFields" },
  { id: 9, name: "countAdverbs", label: "CountAdverbs", key: "countAdverbsFields" },
  { id: 10, name: "countAdjectives", label: "CountAdjectives", key: "countAdjectivesFields" },
  { id: 11, name: "countNouns", label: "CountNouns", key: "countNounsFields" },
]

const FORMULAS_SECTION_FIELDS = [
  { id: 1, name: "formulaCLIX", label: "FormulaCLIX", key: "formulaCLIXFields" },
  { id: 2, name: "formulaARI", label: "FormulaARI", key: "formulaARIFields" },
  { id: 3, name: "formulaColemanLiauIndex", label: "FormulaColemanLiauIndex", key: "formulaColemanLiauIndexFields" },
  { id: 4, name: "formulaFlesch", label: "FormulaFlesch", key: "formulaFleschFields" },
  { id: 5, name: "formulaFLeschKincaid", label: "FormulaFLeschKincaid", key: "formulaFLeschKincaidFields" },
  { id: 6, name: "formulaGunningFogIndex", label: "FormulaGunningFogIndex", key: "formulaGunningFogIndexFields" },
  { id: 7, name: "formulaSMOG", label: "FormulaSMOG", key: "formulaSMOGFields" },
  { id: 8, name: "formulaLIX", label: "FormulaLIX", key: "formulaLIXFields" },
  { id: 9, name: "formulaRIX", label: "FormulaRIX", key: "formulaRIXFields" },
  { id: 10, name: "formulaHix", label: "FormulaHix", key: "formulaHixFields" },
  { id: 11, name: "formulaLanguageLevel", label: "FormulaLanguageLevel", key: "formulaLanguageLevelFields" },
]
const EXCEEDANCES_SECTIONS_FIELDS = [
  { id: 1, name: "moreClausesInWords", label: "MoreClausesInWords", key: "moreClausesInWordsFields" },
  { id: 2, name: "moreSentencesInClauses", label: "MoreSentencesInClauses", key: "moreSentencesInClausesFields" },
  { id: 3, name: "moreSentencesInWords", label: "MoreSentencesInWords", key: "moreSentencesInWordsFields" },
  { id: 4, name: "moreWordsInLetters", label: "MoreWordsInLetters", key: "moreWordsInLettersFields" },
  { id: 5, name: "moreSentencesInBrackets", label: "MoreSentencesInBrackets", key: "moreSentencesInBracketsFields" },
  { id: 6, name: "moreSentencesInPrepositions", label: "MoreSentencesInPrepositions", key: "moreSentencesInPrepositionsFields" },
  { id: 7, name: "countMarkExclamation", label: "CountMarkExclamation", key: "countMarkExclamationFields" },
  { id: 8, name: "moreSentencesInVerbalBlocks", label: "MoreSentencesInVerbalBlocks", key: "moreSentencesInVerbalBlocksFields" },
  { id: 9, name: "moreParagraphsInWords", label: "MoreParagraphsInWords", key: "moreParagraphsInWordsFields" },
]

const listSectionFields = [
  { id: 1, name: "allow_list_sections", listInitial: 'listAllowedListTerms_list', field: 'listAllowedListTermsFields' },
  { id: 2, name: 'corporate_language_sections', listInitial: 'listCorporateLanguageTerms_list', field: 'listCorporateLanguageTermsFields' },
  { id: 3, name: 'text_cleaning_sections', listInitial: 'listTextCleaningTerms_list', field: 'listTextCleaningTermsFields' },
  { id: 4, name: 'terms_sections', listInitial: 'listTerms_list', field: 'listTermsFields' },
  { id: 5, name: 'language_level_sections', listInitial: 'listLanguageLevelTerms_list', field: 'listLanguageLevelTermsFields' },
]

const allTextTypeFields = {
  OTHER_SECTIONS_FIELDS, TONALITY_SECTION_FIELDS, AI_SECTIONS_FIELDS, AVERAGES_SECTION_FIELDS, COLOR_WORD_SECTIONS_FIELDS, COUNTING_SECTION_FIELDS, FORMULAS_SECTION_FIELDS, EXCEEDANCES_SECTIONS_FIELDS, PART_OF_SPEECH_COUNT_SECTION_FIELDS, 
}

const TABS_TEXTTYPE = {
  RIGHTS : 'rights',
  SETTINGS : 'settings',
}

const BUTTON_REF = {
  SAVE : 'save',
  SAVE_N_GO : 'saveAndGo',
}

const textTypedefaultValues = {
  BENCHMARK_TEMPLATE : 2
}

const textTypeExcludedFieldList = ['termCategory', 'abbreviations', 'exceptionWords', 'exeptionCategory']

const defaultRowStateColBasin = { enabled: false, ids: [], all: false, email: false }

const colBasinRowOrder = [
    { key: 'add', label: 'profile_notifications_add' },
    { key: 'daily_reminder', label: 'profile_notifications_daily' },
    { key: 'weekly_reminder', label: 'profile_notifications_weekly' },
    { key: 'monthly_reminder', label: 'profile_notifications_monthly' },
]

const AI_TYPE = {
  AI_ASSISTANT: 'ai_assistant',
  AI_SUMM: 'ai_summ',
}

const BAR_TYPE = {
  PROGRESS : 'progress',
  WARNING: 'warning',
  ERROR : 'error',
}

const THEMES_MODES = {
  LIGHT: 'light',
  CONTRAST_LIGHT: 'contrast-light',
  CONTRAST_DARK: 'contrast-dark',
}
const themes = ["light", "contrast-light", "contrast-dark"]

// '/static/tinymce-inner-styles/dark.css' : '/static/tinymce-inner-styles/light.css'

const THEME_CONFIG = {
  [THEMES_MODES.LIGHT]: {
    skin: 'oxide',
    contentCss: '/static/tinymce-inner-styles/light.css',
  },
  [THEMES_MODES.CONTRAST_LIGHT]: {
    skin: 'oxide-light',
    contentCss: '/static/tinymce-inner-styles/contrast-light.css',
  },
  [THEMES_MODES.CONTRAST_DARK]: {
    skin: 'oxide-dark',
    contentCss: '/static/tinymce-inner-styles/dark.css',
  },
}

const SPINNER_COLORS = {
  [THEMES_MODES.LIGHT]: {
    primary: '#195081',
    secondary: '#9d9d9c',
    dotPrimary: '#195081',
    dotSecondary: '#9d9d9c',
    overlayFallback: 'rgb(255,255,255)',
    overlay: 'rgba(255,255,255,0.7)',
  },
  [THEMES_MODES.CONTRAST_LIGHT]: {
    primary: '#000000',
    secondary: '#1a1a1a',
    dotPrimary: '#000000',
    dotSecondary: '#1a1a1a',
    overlayFallback: 'rgb(255,255,255)',
    overlay: 'rgba(255,255,255,0.7)',
  },
  [THEMES_MODES.CONTRAST_DARK]: {
    primary: '#ffffff',
    secondary: '#f1f1f1',
    dotPrimary: '#ffffff',
    dotSecondary: '#000000',
    overlayFallback: 'rgb(0,0,0)',
    overlay: 'rgba(0,0,0,0.7)',
  },
}

// administration array, backend emulating
const administration = [
  {
    section: 'administration',
    rights: [101, 201],
    id: 0, title: 'Users',
    logo: {
      [THEMES_MODES.LIGHT]: <img className={`mr-4`} src={benutzerIcon} alt=""/>,
      [THEMES_MODES.CONTRAST_LIGHT]: <img className={`mr-4`} src={benutzerIconLight} alt=""/>,
      [THEMES_MODES.CONTRAST_DARK]: <img className={`mr-4`} src={benutzerIconDark} alt=""/>,
    },
    link: '/administration/user',
  },
  {
    section: 'administration',
    rights: [306, 307, 308, 309],
    id: 4, title: 'Companies',
    logo: {
      [THEMES_MODES.LIGHT]: <img className={`mr-4`} src={companyIcon} alt=""/>,
      [THEMES_MODES.CONTRAST_LIGHT]: <img className={`mr-4`} src={companyIconLight} alt=""/>,
      [THEMES_MODES.CONTRAST_DARK]: <img className={`mr-4`} src={companyIconDark} alt=""/>,
    },
    link: '/administration/company',
  },
  {
    section: 'administration',
    rights: [206],
    id: 1, title: 'Groups',
    logo: {
      [THEMES_MODES.LIGHT]: <img className={`mr-4`} src={groupIcon} alt=""/>,
      [THEMES_MODES.CONTRAST_LIGHT]: <img className={`mr-4`} src={groupIconLight} alt=""/>,
      [THEMES_MODES.CONTRAST_DARK]: <img className={`mr-4`} src={groupIconDark} alt=""/>,
    },
    link: '/administration/groups',
  },
  {
    section: 'administration',
    rights: [601, 602],
    id: 3, title: 'Text types',
    logo: {
      [THEMES_MODES.LIGHT]: <img className={`mr-4`} src={textSortIcon} alt=""/>,
      [THEMES_MODES.CONTRAST_LIGHT]: <img className={`mr-4`} src={textSortIconLight} alt=""/>,
      [THEMES_MODES.CONTRAST_DARK]: <img className={`mr-4`} src={textSortIconDark} alt=""/>,
    },
    link: '/administration/text-types',
  },
  {
    section: 'administration',
    rights: [701, 702, 703],
    id: 2, title: 'Terminology menu',
    logo: {
      [THEMES_MODES.LIGHT]: <img className={`mr-4`} src={terminologiesIcon} alt=""/>,
      [THEMES_MODES.CONTRAST_LIGHT]: <img className={`mr-4`} src={terminologiesIconLight} alt=""/>,
      [THEMES_MODES.CONTRAST_DARK]: <img className={`mr-4`} src={terminologiesIconDark} alt=""/>,
    },
    link: '/administration/terminology',
  },
  {
    section: 'administration',
    rights: [131, 231, 701, 702, 703],
    id: 6, title: 'Allowed terms',
    logo: {
      [THEMES_MODES.LIGHT]: <img className={`mr-4`} src={alIcon} alt=""/>,
      [THEMES_MODES.CONTRAST_LIGHT]: <img className={`mr-4`} src={alIconLight} alt=""/>,
      [THEMES_MODES.CONTRAST_DARK]: <img className={`mr-4`} src={alIconDark} alt=""/>,
    },
    link: '/administration/terminology/allowedList',
  },
  {
    section: 'administration',
    rights: [141, 241, 701, 702, 703],
    id: 5, title: 'textbins',
    logo: {
      [THEMES_MODES.LIGHT]: <img className={`mr-4`} src={textBinIcon} alt=""/>,
      [THEMES_MODES.CONTRAST_LIGHT]: <img className={`mr-4`} src={textBinIconLight} alt=""/>,
      [THEMES_MODES.CONTRAST_DARK]: <img className={`mr-4`} src={textBinIconDark} alt=""/>,
    },
    link: '/administration/terminology/textbin',
  }
  // {
  //     rights: [601,602],
  //     id: 4, title: "Cleanup rules",
  //     logo: <img className={`mr-4`} src={cleanUpRulesIcon} alt=""/>,
  //     link: "/administration/cleaning-rules",
  //     content: [
  //         {text: "Cleanup rules", link: "/administration/cleaning-rules", rights: [601,602]},
  //         {text: "Placeholder", link: "/administration/platzhalter", rights: [601,602]}
  //     ]
  // },
  // {  rights: [],
  //     id: 5, title: "Info",
  //     logo: <img className={`mr-4`} src={infoIcon} alt=""/>,
  //     link: "/administration/info/best-practice",
  //     content: [
  //         {text: "Best Practice", link: "/administration/info/best-practice", rights: []},
  //         {text: "Info Messages", link: "/administration/info/info-messages", rights: []},
  //         {text: "Logs", link: "/administration/info/logs", rights: [403]}
  //     ]
  // },
  // {
  //     rights: [306],
  //     id: 6, title: "Companies",
  //     logo: <div className={`mr-2 d-flex align-items-center justify-content-center`}
  //                          style={{borderRadius: "50%", width: "75px", height: "75px"}}>
  //         <ApartmentIcon style={{fill: "white", height: "45px", width: "45px"}}/>
  //     </div>,
  //     link: "/administration/company",
  //     content: [
  //         {text: "Companies", link: "/administration/company",rights: [306]},
  //         {text: "Company options", link: "/administration/company",rights: [309]},
  //     ]
  // },
]

const sortedFrontendSections = [["archive", "dashboard", "dashboard-compare"], ["administration", "allowedlist", "textbin"], ["countPassiveVoiceInSentence_suggestions_de", "moreSentencesInWords_suggestions_de", "moreSentencesInClauses_suggestions_de"], ["double-interface", "ai_summ", "ai_assistant"], ["iframe", "rv-processing"]]

const companyFESections = [...sortedFrontendSections, ['ga_2fa_enabled', 'ga_2fa_disabled']]

// set links by config
let linksArr = [
  { to: '/', text: 'Start / Text editing', img: homeIcon, name: 'home', accessKey: accessKeys.home },
  { to: '/ainstein', text: 'ai_mode', img: combotIcon, section: 'double-interface', accessKey: accessKeys.aiMode },
  { to: '/text-generation', text: 'navbar_text-generator', img: lightBulbIcon, section: 'double-interface', accessKey: accessKeys.generatorMode },
  { to: '/administration', text: 'Administration', img: settingsIcon, section: 'administration', accessKey: accessKeys.administration },
  { to: '/archive', text: 'Archive', img: archivIcon, section: 'archive', accessKey: accessKeys.archive },
  { to: '/dashboard/compare', text: 'Dashboard', img: statistikIcon, section: 'dashboard-compare', accessKey: accessKeys.dashboardCompare },
  { to: '/static/docs/TL9-Benutzer-Handbuch.pdf', text: 'TL8 Handbook', icon: HelpOutline, name: 'view-pdf', accessKey: accessKeys.handbook }
];


const dashboardParameters = {
  HIX: [
    'ColumnCharts'

  ]
}

const tonalityParameters = {
  formulaTonalityScaleValue: {
    appearFirst: 'Appear negative',
    appearSecond: 'Appear positive',
    explanation: 'Explanation positive-negative',
    firstPartChart: [
      { value: 'dataTonalityNegative', name: 'nameTonalityNegative', countBase: 'countWords', type: 'terms' },
      {
        value: 'countTonalityClauseNegative',
        name: 'nameTonalityClauseNegative',
        countBase: 'countClauses',
        type: 'array'
      }
    ],
    secondPartChart: [
      { value: 'dataTonalityPositive', name: 'nameTonalityPositive', countBase: 'countWords', type: 'terms' },
      {
        value: 'countTonalityClausePositive',
        name: 'nameTonalityClausePositive',
        countBase: 'countClauses',
        type: 'array'
      }
    ],
    nameOnTop: 'positive',
    scaleFrom: [-10, 'negative'],
    scaleTo: [10, 'positive'],
    defaultPosition: 0,
    scaleStep: 2
  },
  formulaPersonalNeutralScaleValue: {
    appearFirst: 'Appear neutral',
    appearSecond: 'Appear personal',
    explanation: 'Explanation personal-neutral',
    firstPartChart: [
      { value: 'dataTonalityNeutral', name: 'nameTonalityNeutral', countBase: 'countWords', type: 'terms' }
    ],
    secondPartChart: [
      { value: 'dataTonalityPersonal', name: 'nameTonalityPersonal', countBase: 'countWords', type: 'terms' }
    ],
    nameOnTop: 'personal',
    scaleFrom: [-10, 'neutral'],
    scaleTo: [10, 'personal'],
    defaultPosition: 0,
    scaleStep: 2
  }
}

// LExcel export list

const excelExportList = [
  {
    name: 'PartsOfSpeech',
    translation: 'PartsOfSpeech',
    children: [
      {
        name: 'countNouns',
        request: 'countNouns',
        translation: 'countNouns1',
        children: [],
        language: ['en_GB', 'de_DE']

      },
      {
        name: 'countAdjectives',
        request: 'countAdjectives',
        translation: 'countAdjectives1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countNumbers',
        request: 'countNumbers',
        translation: 'countNumbers',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countVerbs',
        request: 'countVerbs',
        translation: 'countVerbs1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countArticles',
        request: 'countArticles',
        translation: 'countArticles1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countParticles',
        request: 'countParticles',
        translation: 'countParticles1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countPronouns',
        request: 'countPronouns',
        translation: 'countPronouns1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countConjunctions',
        request: 'countConjunctions',
        translation: 'countConjunctions1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countPrepositions',
        request: 'countPrepositions',
        translation: 'countPrepositions1',
        children: [],
        language: ['en_GB', 'de_DE']
      }, {
        name: 'countMisc',
        request: 'countMisc',
        translation: 'countMisc1',
        children: [],
        language: ['en_GB', 'de_DE']

      }
    ]
  },
  {
    name: 'Counts',
    translation: 'Counts',
    children: [
      {
        name: 'countHeading',
        request: 'countHeading',
        translation: 'countHeading1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countParagraphs',
        request: 'countParagraphs',
        translation: 'countParagraphs1',
        children: [],
        language: ['en_GB', 'de_DE']

      },
      {
        name: 'countSubjunctiveClauses',
        request: 'countParcountSubjunctiveClausesagraphs',
        translation: 'countSubjunctiveClauses1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countSubjunctiveVerbs',
        request: 'countSubjunctiveVerbs',
        translation: 'countSubjunctiveVerbs1',
        children: [],
        language: ['en_GB', 'de_DE']

      },
      {
        name: 'countSentences',
        request: 'countSentences',
        translation: 'countSentences1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countClauses',
        request: 'countClauses',
        translation: 'countClauses1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countSyllables',
        request: 'countSyllables',
        translation: 'countSyllables1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countCharactersNoSpaces',
        request: 'countCharactersNoSpaces',
        translation: 'countCharactersNoSpaces1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countCharacters',
        request: 'countCharacters',
        translation: 'countCharacters1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countWords',
        request: 'countWords',
        translation: 'countWords1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countLongestWordInCharacters',
        request: 'countLongestWordInCharacters',
        translation: 'countLongestWordInCharacters1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countLongestSentenceInWords',
        request: 'countLongestSentenceInWords',
        translation: 'countLongestSentenceInWords1',
        children: [],
        language: ['en_GB', 'de_DE']

      },
    ]
  },
  {
    name: 'GrammarAndStyle',
    translation: 'GrammarAndStyle',
    children: [
      {
        name: 'countPassiveVoiceInSentence',
        request: 'countPassiveVoiceInSentence',
        translation: 'countPassiveVoiceInSentence1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countFutureTenseInSentence',
        request: 'countFutureTenseInSentence',
        translation: 'countFutureTenseInSentence1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countInfinitiveConstructions',
        request: 'countInfinitiveConstructions',
        translation: 'countInfinitiveConstructions1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countNominalStyle',
        request: 'countNominalStyle',
        translation: 'countNominalStyle1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'neutralInfinitive',
        request: 'neutralInfinitive',
        translation: 'neutralInfinitive1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'neutralPassive',
        request: 'neutralPassive',
        translation: 'neutralPassive1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'countSttr',
        request: 'countSttr',
        translation: 'countSttr1',
        children: [],
        language: ['en_GB', 'de_DE']

      },
    ]
  },
  {
    name: 'Readability',
    translation: 'Readability',
    children: [
      {
        name: 'meanSentenceLengthInLetters',
        request: 'meanSentenceLengthInLetters',
        translation: 'meanSentenceLengthInLetters1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'meanSentenceLengthInSyllables',
        request: 'meanSentenceLengthInSyllables',
        translation: 'meanSentenceLengthInSyllables1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'meanSentenceLengthInWords',
        request: 'meanSentenceLengthInWords',
        translation: 'meanSentenceLengthInWords1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'meanWordLengthInLetters',
        request: 'meanWordLengthInLetters',
        translation: 'meanWordLengthInLetters1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'meanWordLengthInSyllables',
        request: 'meanWordLengthInSyllables',
        translation: 'meanWordLengthInSyllables1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'meanClauseLengthInLetters',
        request: 'meanClauseLengthInLetters',
        translation: 'meanClauseLengthInLetters1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'meanClauseLengthInSyllables',
        request: 'meanClauseLengthInSyllables',
        translation: 'meanClauseLengthInSyllables1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'meanClauseLengthInWords',
        request: 'meanClauseLengthInWords',
        translation: 'meanClauseLengthInWords1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'moreParagraphsInWords',
        request: 'moreParagraphsInWords',
        translation: 'moreParagraphsInWords',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'moreClausesInWords',
        request: 'moreClausesInWords',
        translation: 'moreClausesInWords',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'moreSentencesInClauses',
        request: 'moreSentencesInClauses',
        translation: 'moreSentencesInClauses',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'moreSentencesInWords',
        request: 'moreSentencesInWords',
        translation: 'moreSentencesInWords',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'moreWordsInLetters',
        request: 'moreWordsInLetters',
        translation: 'moreWordsInLetters',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'moreSentencesInBrackets',
        request: 'moreSentencesInBrackets',
        translation: 'moreSentencesInBrackets',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'moreSentencesInPrepositions',
        request: 'moreSentencesInPrepositions',
        translation: 'moreSentencesInPrepositions',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'moreSentencesInVerbalBlocks',
        request: 'moreSentencesInVerbalBlocks',
        translation: 'moreSentencesInVerbalBlocks',
        children: [],
        language: ['en_GB', 'de_DE']

      }
    ]
  },
  {
    name: 'Tonality',
    translation: 'Tonality',
    children: [
      {
        name: 'formulaTonalityScaleValue',
        request: 'formulaTonalityScaleValue',
        translation: 'formulaTonalityScaleValue1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'formulaPersonalNeutralScaleValue',
        request: 'formulaPersonalNeutralScaleValue',
        translation: 'formulaPersonalNeutralScaleValue1',
        children: [],
        language: ['en_GB', 'de_DE']

      },
    ]
  },
  {
    name: 'Formulas',
    translation: 'Formulas',
    children: [
      {
        name: 'formulaHix',
        request: 'formulaHix',
        translation: 'formulaHix1',
        children: [],
        language: ['de_DE']

      }, {
        name: 'formulaCLIX',
        request: 'formulaCLIX',
        translation: 'formulaCLIX1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'formulaSPIX',
        request: 'formulaSPIX',
        translation: 'formulaSPIX1',
        children: [],
        language: ['en_GB']

      },
    ]
  },
  {
    name: 'LanguageLevel',
    translation: 'languageLevel',
    baseOn: 'formulaLanguageLevel',
    children: [
      {
        name: 'dataLanguageLevel.languageLevel',
        request: 'dataLanguageLevel.languageLevel',
        translation: 'excel_export_dataLanguageLevel_level',
        children: [],
        language: ['de_DE']

      },
      {
        name: 'formulaLanguageLevel',
        request: 'formulaLanguageLevel',
        translation: 'excel_export_formulaLanguageLevel_score',
        children: [],
        language: ['de_DE']

      },
    ]
  },
  {
    name: 'formulaHix',
    translation: 'dataHix',
    baseOn: 'formulaHix',
    children: [
      {
        name: 'dataHix.Amstad',
        request: 'dataHix.Amstad',
        translation: 'dataHix.Amstad',
        children: [],
        language: ['de_DE']
      }, {
        name: 'dataHix.Lix',
        request: 'dataHix.Lix',
        translation: 'dataHix.Lix',
        children: [],
        language: ['de_DE']
      }, {
        name: 'dataHix.GSMOG',
        request: 'dataHix.GSMOG',
        translation: 'dataHix.GSMOG',
        children: [],
        language: ['de_DE']
      }, {
        name: 'dataHix.WSTF',
        request: 'dataHix.WSTF',
        translation: 'dataHix.WSTF',
        children: [],
        language: ['de_DE']

      },
    ]
  },
  {
    name: 'Spelling',
    translation: 'Spelling',
    children: [
      {
        name: 'languageTool',
        request: 'languageTool',
        translation: 'languageTool1',
        children: [],
        language: ['en_GB', 'de_DE']

      }, {
        name: 'dataHunSpell',
        request: 'dataHunSpell',
        translation: 'dataHunSpell1',
        children: [],
        language: ['en_GB', 'de_DE']

      }
    ]
  },
  {
    name: 'Terminology',
    translation: 'Terminology',
    startWith: 'dataTerms.',
    children: []
  },
  {
    name: 'CorporateLanguage',
    translation: 'CorporateLanguage',
    startWith: 'dataCorporateLanguage.',
    children: [
      {
        ignoreStart: true,
        name: 'countMarkExclamation',
        request: 'countMarkExclamation',
        translation: 'countMarkExclamation',
        children: [],
        language: ['en_GB', 'de_DE']

      }
    ]
  },
  {
    name: 'Colorwords',
    translation: 'Colorwords',
    children: [
      {
        name: 'colorBlue',
        request: 'colorBlue',
        translation: 'colorBlue',
        children: [],
        language: ['de_DE']

      }, {
        name: 'colorRed',
        request: 'colorRed',
        translation: 'colorRed',
        children: [],
        language: ['de_DE']

      }, {
        name: 'colorGreen',
        request: 'colorGreen',
        translation: 'colorGreen',
        children: [],
        language: ['de_DE']

      }, {
        name: 'colorYellow',
        request: 'colorYellow',
        translation: 'colorYellow',
        children: [],
        language: ['de_DE']

      },
    ]
  },
]

const config = {
  aiDefaultTextSize: 4000,
  clixDisplay: [
    {
      title: 'Spelling',
      subCat: [
        'languageTool',
        'dataHunSpell'
      ]
    },
    {
      title: 'Counts',
      subCat: [
        'countLongestSentenceInWords',
        'countNumbers',
        'countSentences',
        'countClauses',
        'countSyllables',
        'countCharactersNoSpaces',
        'countCharacters',
        'countWords',
        'countLongestWordInCharacters',
        'countHeading',
        'countParagraphs'
      ]
    },
    {
      title: 'Readability',
      subCat: [
        'moreClausesInWords',
        'moreSentencesInClauses',
        'moreSentencesInWords',
        'moreWordsInLetters',
        'meanSentenceLengthInLetters',
        'meanSentenceLengthInSyllables',
        'meanSentenceLengthInWords',
        'meanWordLengthInLetters',
        'meanWordLengthInSyllables',
        'meanClauseLengthInLetters',
        'meanClauseLengthInSyllables',
        'meanClauseLengthInWords',
        'moreParagraphsInWords',
        'moreSentencesInBrackets',
        'moreSentencesInPrepositions',
        'moreSentencesInVerbalBlocks'
      ]
    },
    {
      title: 'Linguistic climate',
      subCat: [
        'colorBlue',
        'colorRed',
        'colorGreen',
        'colorYellow'
      ]
    },
    {
      title: 'Terminology',
      subCat: [
        // 'Nominalisierungen',
        // 'Finanzen und Versicherungen',
        // 'Doppelt gemoppelt',
        // 'Gender',
        // 'Komposita',
        // 'Juristendeutsch',
        // 'Negative Formulierungen',
        // 'Konjunktiv und vage',
        // 'Floskeln und Verstaubtes',
        // 'Attribute',
        // 'Verneinung',
        // 'Abkürzungen',
        // 'Füllwörter'
      ]
    },
    {
      title: 'CorporateLanguage',
      subCat: [
        // 'dataCorporateLanguage'
        // "Stopp!",
        // "Spelling rules",
        // "Corporate Wording",
        // "Call to action",
        // "Anglizisms",
        // "Bank detail",
        // "Date",
        // "Phone numbers",
        // "Time",
        // "Currency",
        // "Exclamation Marks",
        // "Filler words",
      ]
    },
    {
      title: 'Tonality',
      subCat: [
        'formulaTonalityScaleValue',
        'formulaPersonalNeutralScaleValue',
        'countTonalityAllPositive',
        'countTonalityAllNegative',
        'countTonalityClausePositive',
        'countTonalityClauseNegative',
        'countTonalityParagraphPositive',
        'countTonalityParagraphNegative',
        'dataTonalityPositive',
        'dataTonalityNegative',
        'countTonalityAllPersonal',
        'countTonalityAllNeutral',
        'countTonalityClausePersonal',
        'countTonalityClauseNeutral',
        'countTonalityParagraphPersonal',
        'countTonalityParagraphNeutral',
        'dataTonalityPersonal',
        'dataTonalityNeutral',
        'countScorePersonal',
        'countScoreNeutral'
      ]
    },
    {
      title: 'GrammarAndStyle',
      subCat: [
        'countPassiveVoiceInSentence', 'countInfinitiveConstructions',
        'countFutureTenseInSentence', 'countNominalStyle',
        'countSttr'
      ]
    },
    {
      title: 'PartsOfSpeech',
      subCat: [
        'countNouns',
        'countAdverbs',
        'countAdjectives',
        'countVerbs',
        'countArticles',
        'countParticles',
        'countPronouns',
        'countConjunctions',
        'countPrepositions',
        'countMisc',
      ]
    }
  ],

  multiWords: [
    'moreParagraphsInWords',
    'moreClausesInWords',
    'moreSentencesInBrackets',
    'moreSentencesInClauses',
    'moreSentencesInPrepositions',
    'moreSentencesInWords',
    'moreSentencesInVerbalBlocks'],

  minPasswordLength: 5,
  minRestorePasswordCodeLength: 5,
  dashboardParameters: dashboardParameters,
  hixFleschFilter: [
    'moreParagraphsInWords',
    'moreClausesInWords',
    'moreSentencesInClauses',
    'moreSentencesInWords',
    'moreSentencesInBrackets',
    'moreSentencesInPrepositions',
    'moreWordsInLetters',
    'moreSentencesInVerbalBlocks'
  ],
  dangerousTags: [
    'pre',
    'div',
    'comment',
    'embed',
    'link',
    'listing',
    'meta',
    'noscript',
    'object',
    'plaintext',
    'script',
    'xmp'
  ],
  modalAccordionComponents: {
    Spell: Spell,
    LinguisticClimate: LinguisticClimate,
    Readability: Readability,
    CorporateLanguage: CorporateLanguage,
    Terminology: Terminology,
    Tonality: Tonality,
    GrammarAndStyle: GrammarAndStyle,
    Experimental: Experimental
  },
  modalComponents: {
    TextClassification: InfoModal,
    LanguageTool: LanguageToolModal,
    Spell: SpellModal,
    LinguisticClimate: LinguisticClimateModal,
    Readability: ReadabilityModal,
    ReadabilitySuggestion: SuggestionModal,
    GrammarAndStyle: SuggestionModal,
    PositiveTerminology: InfoModal,
    AllowList: InfoModal,
    CorporateLanguage: TerminologyModal,
    Terminology: TerminologyModal,
    Tonality: InfoModal
  },

  accordionsForGreenFilterInfo: [
    "Readability",
    "GrammarAndStyle",
    "CorporateLanguage",
    "Terminology"
  ],

  accordions: {
    Spell: [
      'languageTool',
      'dataHunSpell'
    ],
    LinguisticClimate: [
      'dataColorWords'
    ],
    Experimental: [
      'dataTextClassification'
    ],
    Readability: [
      'moreClausesInWords', 'moreSentencesInClauses',
      'moreSentencesInWords', 'moreWordsInLetters',
      'moreSentencesInVerbalBlocks'
    ],
    Terminology: [
      'dataTerms'
    ],
    CorporateLanguage: [
      'dataCorporateLanguage', 'countMarkExclamation'
    ],
    Tonality: [
      'formulaTonalityScaleValue', 'formulaPersonalNeutralScaleValue'
    ],
    GrammarAndStyle: [
      'countPassiveVoiceInSentence', 'countInfinitiveConstructions',
      'countFutureTenseInSentence', 'countNominalStyle'
    ]
  },
  fullCountBase: {
    countMarkExclamation: 'countWords',
    countPassiveVoiceInSentence: 'countClauses',
    countInfinitiveConstructions: 'countClauses',
    countFutureTenseInSentence: 'countClauses',
    countNominalStyle: 'countClauses',
    countLongestSentenceInWords: 'countSentences',
    countLongestWordInCharacters: 'countWords',
    countTonalityAllPositive: 'countSentences',
    countTonalityAllNegative: 'countSentences',
    countTonalityClausePositive: 'countClauses',
    countTonalityClauseNegative: 'countClauses',
    countTonalityAllPersonal: 'countSentences',
    countTonalityAllNeutral: 'countSentences',
    countTonalityClausePersonal: 'countClauses',
    countTonalityClauseNeutral: 'countClauses',
    countScorePersonal: '',
    countScoreNeutral: '',
    formulaTonalityScaleValue: '',
    formulaPersonalNeutralScaleValue: '',
    formulaHix: '',
    formulaCLIX: '',
    dataTonalityPositive: 'countWords',
    dataTonalityNegative: 'countWords',
    dataTonalityPersonal: 'countWords',
    dataTonalityNeutral: 'countWords',
    moreSentencesInClauses: 'countSentences',
    moreClausesInWords: 'countClauses',
    moreSentencesInPhrases: 'countSentences',
    moreSentencesInWords: 'countSentences',
    moreWordsInLetters: 'countWords',
    moreSentencesInBrackets: 'countSentences',
    moreSentencesInPrepositions: 'countSentences'
  },
  tonalityParameters: tonalityParameters,
  minSize: 10,
  defaultAnalyseLanguageTextType: {
    language: 'auto',
    textType: {},
  },
  defaultAnalyseTonality: {
    remember: false,
    ...Object.entries(tonalityParameters).reduce((acc, [key, value]) => {
      return { ...acc, [key]: value.defaultPosition }
    }, {})
  },
  defaultColBasinReport: {
  allowlist: {
    add: {
      all: false,
      email: false,
      enabled: false,
      ids: [],
    },
    daily_reminder: {
      all: false,
      email: false,
      enabled: false,
      ids: [],
    },
    monthly_reminder: {
      all: false,
      email: false,
      enabled: false,
      ids: [],
    },
    weekly_reminder: {
      all: false,
      email: false,
      enabled: false,
      ids: [],
    }
  },

  textbin: {
    add: {
      all: false,
      email: false,
      enabled: false,
      ids: [],
    },
    daily_reminder: {
      all: false,
      email: false,
      enabled: false,
      ids: [],
    },
    monthly_reminder: {
      all: false,
      email: false,
      enabled: false,
      ids: [],
    },
    weekly_reminder: {
      all: false,
      email: false,
      enabled: false,
      ids: [],
    }
  }
},

  defaultUserRedirects: {
    'redirect/Assistant': false,
    'redirect/Summ': false
  },
  themeSwitchIsAlwaysDisabled: false,
  messagesInterval: 60000,
  tokenUpdateInterval: 5000,
  linksArr,
  administration,
  timeOutDuration: 7000,
  localStorageTokenName: 'token',
  defaultTextType: 'letter',
  enabledThemes: ['light', 'dark'],
  termCategoryOptionSet: ['color'],
  meaningTypesList: {
    v: 'vovel',
    o: 'object',
    n: 'nonun'
  },
  messagesLevels: {
    alert: 'alert',
    warning: 'warning',
    info: 'info'
  },
  messagesTemplates: {
    'text_message' : TextMessagesTemplate,
    'text_message_no_answer' : TextMessagesTemplate,
    'must_change_password' : TextMessagesTemplate,
    'terms_and_conditions' : TextMessagesTemplate
  },
  termSettings: ['color'],
  excelExportList,
  categoryTypeList,
  userSettingColor,
  archiveTypes,
  defaultArchiveColumns,
  defaultUsersColumns,
  userRights,
  options,
  enabledUserOptions,
  userRightsGroupLevel,
  singleGroupLevel,
  companyLevel,
  overCompanyLevel,
  specialRights,
  clixCategories,
  clixDigits,
  clixArrays,
  compareShowValues,
  compareThemeColors,
  dataHixValues,
  compareShowValuesCLIX,
  LINGUISTIC_CLIMATE_TITLE_INITIALS,
  colorKeyToTitle,
  termHeaders,
  chartMax,
  autoAnalyseLanguage,
  neededValues,
  languageLevelToString,
  wordsCloudTemplate,
  sortedFrontendSections,
  companyFESections,
  accessKeys,
  pageMeta,
  keyAttributes,
  tabIndexes,
  processSettings,
  allTextTypeFields,
  allSectionNames,
  allSectionNamesAdmin,
  textTypeTableHeaders,
  catTypes,
  TABS_TEXTTYPE,
  BUTTON_REF,
  listNestedFields,
  textTypedefaultValues,
  textTypeExcludedFieldList,
  fieldSequence,
  AI_TYPE,
  defaultRowStateColBasin,
  colBasinRowOrder,
  BAR_TYPE,
  THEMES_MODES,
  themes,
  THEME_CONFIG,
  SPINNER_COLORS,
  listSectionFields
}

export default config